import { gql } from '@apollo/client';

const CREATE_USER = gql`
  mutation registerUser($input: RegisterUserInput!) {
    registerUser(input: $input) {
      loginResult: result {
        id
        cartId
        result: authResult {
          accessToken
          refreshToken
        }
      }
    }
  }
`;

const UPDATE_USER = gql`
  mutation updateRegisteredUser($input: UpdateRegisteredUserInput!) {
    updateRegisteredUser(input: $input) {
      result {
        id
      }
    }
  }
`;

export { CREATE_USER, UPDATE_USER };
